import httpClient from "../../../shared/api/httpClient";

// Escala fixa: regras de plantão recorrente (semanal, quinzenal ou mensal) de cada vínculo,
// e a geração dos plantões de um mês a partir delas — o médico confere a prévia e confirma.
export const shiftPatternsApi = {
  listByVinculo: (vinculoId) =>
    httpClient.get(`/api/v1/vinculos/${vinculoId}/shift-patterns`).then((r) => r.data.dados ?? []),

  // Ordem no mês e dia da semana só vão no mensal: nas demais o backend os recusa (422),
  // porque o dia da semana sai da data do primeiro plantão.
  create: ({ vinculoId, startDate, frequency, weekOfMonth, weekday }) =>
    httpClient
      .post(
        `/api/v1/vinculos/${vinculoId}/shift-patterns`,
        frequency === "monthly"
          ? { start_date: startDate, frequency, week_of_month: weekOfMonth, weekday }
          : { start_date: startDate, frequency }
      )
      .then((r) => r.data.dados),

  remove: (id) => httpClient.delete(`/api/v1/shift-patterns/${id}`).then((r) => r.data),

  preview: ({ year, month }) =>
    httpClient.get(`/api/v1/shift-patterns/preview?ano=${year}&mes=${month}`).then((r) => r.data.dados),

  // items: datas a registrar; skipped: datas desmarcadas na prévia (folga, troca).
  // Os dois no formato [{ vinculo_id, data: "yyyy-MM-dd" }].
  generate: ({ items, skipped = [] }) =>
    httpClient.post("/api/v1/shift-patterns/generate", { items, skipped }).then((r) => r.data.dados),
};
